import React, { FC, useCallback } from 'react';
import 'reactjs-popup/dist/index.css';
import { ISelectOption } from '@widgets/multi-select';
import SingleSelectForm from '@shared/form/SingleSelectForm';
import { Controller, useForm } from 'react-hook-form';
import TextForm from '@shared/form/TextForm';
import IconCross from '@shared/icons/IconCross';
import TextInputWithSignForm from '@shared/form/TextInputWithSignForm';
import Label from '@shared/uikit/label';
import BaseAccountPopupCreate from '@pages/Account/Create/component/BaseAccountPopupCreate';
import useAccountCreateOptions from '@pages/Account/hooks/useAccountCreateOptions';
import HostingCreatePopup from '@pages/Hosting/List/component/HostingCreatePopup';
import useHostingCreateOptions from '@pages/Hosting/List/hooks/useHostingCreateOptions';

interface IProps {
  onClose: () => void;
  onSubmit: (data: ICreateHostingValues) => void;
}

export interface ICreateHostingValues {
  name: string;
  location: ISelectOption;
  status: ISelectOption;
  nominalPower: string;
  actualPower: string;
  interhostPart: string;
}

const DEFAULT_FORM_VALUES = {
  name: '',
  location: null,
  status: null,
  nominalPower: null,
  actualPower: null,
  interhostPart: null,
};

export const HostingCreate: FC<IProps> = ({ onClose, onSubmit }) => {
  const optionsFetcher = useHostingCreateOptions();

  const {
    handleSubmit,
    control,
    reset,
    formState: { isSubmitting },
  } = useForm<any>({});

  const onClear = useCallback(() => reset({ ...DEFAULT_FORM_VALUES }), []);

  const onCreateAccount = async (values: any) => {
    await onSubmit(values);
  };

  return (
    <HostingCreatePopup
      width="500px"
      onClear={onClear}
      onSubmit={handleSubmit(onCreateAccount)}
      onClose={onClose}
      isSubmitting={isSubmitting}
    >
      <div className="border-b border-solid pb-[15px] border-opacity-10 border-[#959595] relative">
        <input type="hidden" />
        <div className="flex items-center">
          <Controller
            name={`name`}
            control={control}
            render={({ field, fieldState }) => (
              <TextForm
                width="250px"
                placeholder="Введите новый аккаунт"
                value={field.value}
                onChange={val => {
                  field.onChange(val);
                }}
                state={fieldState}
              />
            )}
            rules={{ required: true }}
          />
        </div>
        <div className="absolute right-0 top-[10px] cursor-pointer" onClick={onClose}>
          <IconCross />
        </div>
      </div>

      <div className="grid grid-cols-[1fr_1fr] gap-3 justify-items-start items-center py-[20px] border-b border-solid border-opacity-10 border-[#959595]">
        <Controller
          name="location"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Локация" color="white" />
              <SingleSelectForm
                placeholder="Выберите локацию"
                isLoading={!optionsFetcher.isLoading}
                options={optionsFetcher.locationsOptions}
                width="270px"
                onChange={(val: ISelectOption | null) => field.onChange(val)}
                value={field.value}
                state={fieldState}
              />
            </>
          )}
          rules={{ required: true }}
        />
        <Controller
          name="status"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Статус" color="white" />
              <SingleSelectForm
                placeholder="Выберите статус"
                isLoading={!optionsFetcher.isLoading}
                options={optionsFetcher.statusesOptions}
                width="270px"
                onChange={(val: ISelectOption | null) => field.onChange(val)}
                value={field.value}
                state={fieldState}
              />
            </>
          )}
          rules={{ required: true }}
        />
        <Controller
          name={`nominalPower`}
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Номин. мощность" color="white" />
              <div className="w-full flex items-center gap-2 text-white">
                <div className="ml-auto w-[100px]">
                  <TextForm
                    value={field.value}
                    onChange={val => {
                      field.onChange(val);
                    }}
                    placeholder=""
                    state={fieldState}
                  />
                </div>
                Мвт
              </div>
            </>
          )}
          rules={{ required: true }}
        />
        <Controller
          name={`actualPower`}
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Факт. мощнность" color="white" />
              <div className="w-full flex items-center gap-2 text-white">
                <div className="ml-auto w-[100px]">
                  <TextForm
                    value={field.value}
                    onChange={val => {
                      field.onChange(val);
                    }}
                    placeholder=""
                    state={fieldState}
                  />
                </div>
                Мвт
              </div>
            </>
          )}
          rules={{ required: true }}
        />
        <Controller
          name={`interhostPart`}
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Доля Interhash" color="white" />
              <div className="w-full flex items-center gap-2 text-white">
                <div className="ml-auto w-[100px]">
                  <TextForm
                    value={field.value}
                    onChange={val => {
                      field.onChange(val);
                    }}
                    placeholder=""
                    state={fieldState}
                  />
                </div>
                Мвт
              </div>
            </>
          )}
          rules={{ required: true }}
        />
      </div>
    </HostingCreatePopup>
  );
};
